export const LANGUAGES = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "it", label: "IT" },
];

export const translations = {
  de: {
    nav: {
      home: "Startseite",
      services: "Leistungen",
      about: "Über uns",
      team: "Team",
      contact: "Kontakt",
      cta: "Anfrage senden",
    },
    hero: {
      overline: "Elektro- & IT/EDV-Technik",
      title: "Verlässliche Lösungen. Nachhaltige Verbindungen.",
      subtitle:
        "Die Elvocom AG realisiert präzise, effiziente und zukunftssichere Lösungen in der Elektro- und IT/EDV-Technik – für private, gewerbliche und institutionelle Kunden.",
      primaryCta: "Projekt anfragen",
      secondaryCta: "Unsere Leistungen",
      tagline: "Technik. Kompetenz. Vertrauen.",
    },
    stats: [
      { value: "4", labelKey: "Kernbereiche der Technik" },
      { value: "100%", labelKey: "Termintreue & Qualität" },
      { value: "CH · DE", labelKey: "Schweiz & Süddeutschland" },
    ],
    intro: {
      overline: "Wer wir sind",
      title: "Ihr Partner für Elektro- und Kommunikationstechnik",
      text: "Wir bieten umfassende Lösungen in der Elektro- und IT/EDV-Technik. Mit exzellenter Fachkompetenz und zusätzlicher Kapazität unterstützen wir private Kunden, gewerbliche Auftraggeber und Partnerunternehmen – zuverlässig und flexibel. Unsere Arbeitsweise ist strukturiert, qualitätsbewusst und lösungsorientiert.",
      cta: "Mehr über uns",
    },
    servicesSection: {
      overline: "Leistungen",
      title: "Was wir für Sie umsetzen",
      subtitle:
        "Von der Glasfaser bis zur kompletten Elektroinstallation – alles aus einer Hand.",
      viewAll: "Alle Leistungen ansehen",
    },
    services: [
      {
        key: "fiber",
        title: "Glasfaser / LWL",
        short: "Verlegung, Spleissen und Inbetriebnahme von Lichtwellenleitern.",
        points: [
          "Installation und Montage von Glasfaserkabeln",
          "Spleissen und Messtechnik",
          "Inbetriebnahme und vollständige Dokumentation",
        ],
      },
      {
        key: "network",
        title: "Netzwerk / EDV / Kommunikation",
        short: "Planung, strukturierte Verkabelung und Netzwerktechnik.",
        points: [
          "Planung und Beratung für Netzwerklösungen",
          "Strukturierte Verkabelung (z. B. CAT-Verkabelung)",
          "Aufbau, Konfiguration, Dokumentation und Wartung",
        ],
      },
      {
        key: "broadband",
        title: "Breitband / Kabel / Satellit – Internet & TV",
        short: "Installation von Breitband-, Kabel-, SAT- und TV-Anlagen.",
        points: [
          "Installation von Breitband- und Kabelanlagen",
          "Aufbau von SAT- und TV-Empfangsanlagen",
          "Signalverteilung, Hausverkabelung und Endgeräte",
        ],
      },
      {
        key: "electro",
        title: "Elektro",
        short: "Elektroinstallationen für private und gewerbliche Objekte.",
        points: [
          "Elektroinstallationen und elektronische Arbeiten",
          "Für private und gewerbliche Liegenschaften",
          "Modernisierung und Erweiterung vorhandener Systeme",
        ],
      },
    ],
    valuesSection: {
      overline: "Unsere Werte",
      title: "Warum Kunden uns vertrauen",
    },
    values: [
      {
        title: "Zuverlässigkeit",
        text: "Vertrauen in Qualität und termingerechte Ausführung. Sichere, stabile Installationen für dauerhafte Leistung.",
      },
      {
        title: "Kompetenz",
        text: "Fachwissen und Erfahrung, die überzeugen und für anspruchsvolle Projekte echten Mehrwert schaffen.",
      },
      {
        title: "Partnerschaft",
        text: "Transparente, pünktliche und partnerschaftliche Zusammenarbeit – für langfristigen gemeinsamen Erfolg.",
      },
      {
        title: "Nachhaltigkeit",
        text: "Zukunftssichere Technologien für eine nachhaltige und verantwortungsvolle Umsetzung.",
      },
    ],
    regions: {
      overline: "Einsatzgebiete",
      title: "In der Schweiz und Süddeutschland für Sie im Einsatz",
      text: "Wir betreuen Kunden in der ganzen Schweiz sowie in Baden-Württemberg und Bayern.",
      list: ["Schweiz", "Baden-Württemberg", "Bayern"],
    },
    ctaBand: {
      title: "Bereit für Ihr nächstes Projekt?",
      text: "Lassen Sie uns über Ihre Anforderungen sprechen – wir beraten Sie gerne persönlich.",
      button: "Jetzt Kontakt aufnehmen",
    },
    about: {
      overline: "Über uns",
      title: "Technik. Kompetenz. Vertrauen.",
      lead: "Die Elvocom AG ist ein innovatives Unternehmen für hochwertige Dienstleistungen und individuelle Lösungen in der Elektro- und IT/EDV-Technik.",
      body1:
        "Wir unterstützen private Kunden, gewerbliche Auftraggeber und Partnerunternehmen mit exzellenter Fachkompetenz und zusätzlicher Kapazität – zuverlässig und flexibel. Unsere Arbeitsweise ist strukturiert, qualitätsbewusst und lösungsorientiert.",
      body2:
        "Transparente Kommunikation, persönliches Engagement und termingerechte Fertigstellung sind für uns selbstverständlich. Mit Innovationskraft, Erfahrung und einem klaren Qualitätsanspruch realisieren wir wirtschaftliche und zukunftssichere Lösungen auf höchstem Niveau.",
      missionTitle: "Unser Anspruch",
      mission:
        "Verlässliche Lösungen, kompetente Beratung und nachhaltiger Mehrwert – für langfristige Partnerschaften.",
      founderLabel: "Gründer & Hauptaktionär",
      founder: "Salvatore Giarratana",
    },
    teamPage: {
      overline: "Unser Team",
      title: "Menschen, die Technik beherrschen",
      subtitle:
        "Ein eingespieltes Team aus Elektrikern und Telekommunikationstechnikern.",
      roleManaging: "Geschäftsführer · Elektriker · Telekommunikationstechniker",
      roleDeputy: "Stv. Geschäftsleitung · Telekommunikationstechniker",
      roleElectrician: "Elektriker · Telekommunikationstechniker",
      roleTelecom: "Telekommunikationstechniker",
    },
    contact: {
      overline: "Kontakt",
      title: "Sprechen wir über Ihr Projekt",
      subtitle:
        "Füllen Sie das Formular aus oder kontaktieren Sie uns direkt. Wir melden uns zeitnah bei Ihnen.",
      infoTitle: "Kontaktdaten",
      addressLabel: "Adresse",
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      form: {
        name: "Name",
        namePlaceholder: "Ihr Name",
        email: "E-Mail",
        emailPlaceholder: "ihre@email.ch",
        phone: "Telefon (optional)",
        phonePlaceholder: "+41 ...",
        subject: "Betreff",
        subjectPlaceholder: "Worum geht es?",
        message: "Nachricht",
        messagePlaceholder: "Beschreiben Sie Ihr Anliegen ...",
        submit: "Anfrage senden",
        sending: "Wird gesendet ...",
        success: "Vielen Dank! Ihre Anfrage wurde gesendet.",
        error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        newRequest: "Neue Anfrage",
      },
    },
    footer: {
      tagline: "Verlässliche Lösungen. Nachhaltige Verbindungen.",
      nav: "Navigation",
      services: "Leistungen",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
    },
    legal: {
      impressumTitle: "Impressum",
      datenschutzTitle: "Datenschutzerklärung",
      impressum: {
        companyHeading: "Angaben zum Unternehmen",
        representedByLabel: "Vertreten durch",
        representedBy: "Salvatore Giarratana (Geschäftsführer)",
        contactHeading: "Kontakt",
        registerHeading: "Handelsregister",
        uidLabel: "UID / Handelsregister-Nr.",
        uid: "CHE-165.598.626",
        disclaimerHeading: "Haftungsausschluss",
        disclaimer:
          "Die Inhalte dieser Website wurden mit grösstmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr. Für Inhalte externer Links sind ausschliesslich deren Betreiber verantwortlich.",
        copyrightHeading: "Urheberrecht",
        copyright:
          "Alle Inhalte dieser Website (Texte, Bilder, Logo, Grafiken) sind urheberrechtlich geschützt und dürfen ohne vorherige schriftliche Zustimmung der Elvocom AG nicht vervielfältigt oder verwendet werden.",
      },
      datenschutz: {
        intro:
          "Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und gemäss dem Schweizer Datenschutzgesetz (revDSG) sowie der EU-Datenschutz-Grundverordnung (DSGVO), soweit anwendbar.",
        sections: [
          { h: "1. Verantwortliche Stelle", p: "Verantwortlich für die Datenbearbeitung auf dieser Website ist die Elvocom AG, Wildenstrasse 3, 8212 Neuhausen am Rheinfall. Bei Fragen zum Datenschutz erreichen Sie uns unter info@elvocom.ch." },
          { h: "2. Erhebung von Daten beim Websitebesuch", p: "Beim Aufruf unserer Website werden automatisch technische Zugriffsdaten (z. B. IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp) in Server-Logfiles gespeichert. Diese Daten dienen ausschliesslich dem sicheren und stabilen Betrieb der Website." },
          { h: "3. Kontaktformular", p: "Wenn Sie uns über das Kontaktformular eine Anfrage senden, verarbeiten wir die von Ihnen angegebenen Daten (Name, E-Mail-Adresse, ggf. Telefonnummer, Betreff und Nachricht) zur Bearbeitung Ihrer Anfrage. Die Daten werden in unserer Datenbank gespeichert und zusätzlich per E-Mail an uns übermittelt. Wir speichern diese Daten so lange, wie es zur Bearbeitung erforderlich ist." },
          { h: "4. Cookies & lokale Speicherung", p: "Wir setzen keine Tracking- oder Werbe-Cookies ein. Zur Speicherung Ihrer bevorzugten Sprache verwenden wir ausschliesslich technisch notwendige lokale Speicherung (localStorage) in Ihrem Browser." },
          { h: "5. Weitergabe an Dritte", p: "Ihre Daten werden nicht verkauft. Eine Weitergabe erfolgt nur an Dienstleister, die für den Betrieb der Website und den E-Mail-Versand erforderlich sind (Hosting- und E-Mail-Anbieter), sowie wenn wir gesetzlich dazu verpflichtet sind." },
          { h: "6. Ihre Rechte", p: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten sowie das Recht auf Datenübertragbarkeit. Bitte kontaktieren Sie uns hierzu unter info@elvocom.ch." },
          { h: "7. Änderungen", p: "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht." },
        ],
      },
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      team: "Team",
      contact: "Contact",
      cta: "Get in touch",
    },
    hero: {
      overline: "Electrical & IT/IT-Systems Technology",
      title: "Reliable solutions. Sustainable connections.",
      subtitle:
        "Elvocom AG delivers precise, efficient and future-proof solutions in electrical and IT/IT-systems technology – for private, commercial and institutional clients.",
      primaryCta: "Request a project",
      secondaryCta: "Our services",
      tagline: "Technology. Competence. Trust.",
    },
    stats: [
      { value: "4", labelKey: "Core technology areas" },
      { value: "100%", labelKey: "On-time delivery & quality" },
      { value: "CH · DE", labelKey: "Switzerland & Southern Germany" },
    ],
    intro: {
      overline: "Who we are",
      title: "Your partner for electrical and communication technology",
      text: "We offer comprehensive solutions in electrical and IT/IT-systems technology. With excellent technical expertise and additional capacity, we support private clients, commercial customers and partner companies – reliably and flexibly. Our approach is structured, quality-conscious and solution-oriented.",
      cta: "More about us",
    },
    servicesSection: {
      overline: "Services",
      title: "What we deliver for you",
      subtitle:
        "From fiber optics to complete electrical installation – everything from a single source.",
      viewAll: "View all services",
    },
    services: [
      {
        key: "fiber",
        title: "Fiber Optics / FO",
        short: "Installation, splicing and commissioning of fiber optic cables.",
        points: [
          "Installation and mounting of fiber optic cables",
          "Splicing and measurement technology",
          "Commissioning and complete documentation",
        ],
      },
      {
        key: "network",
        title: "Network / IT / Communication",
        short: "Planning, structured cabling and network technology.",
        points: [
          "Planning and consulting for network solutions",
          "Structured cabling (e.g. CAT cabling)",
          "Setup, configuration, documentation and maintenance",
        ],
      },
      {
        key: "broadband",
        title: "Broadband / Cable / Satellite – Internet & TV",
        short: "Installation of broadband, cable, SAT and TV systems.",
        points: [
          "Installation of broadband and cable systems",
          "Setup of SAT and TV reception systems",
          "Signal distribution, home cabling and end devices",
        ],
      },
      {
        key: "electro",
        title: "Electrical",
        short: "Electrical installations for private and commercial properties.",
        points: [
          "Electrical installations and electronic work",
          "For private and commercial properties",
          "Modernization and expansion of existing systems",
        ],
      },
    ],
    valuesSection: {
      overline: "Our values",
      title: "Why clients trust us",
    },
    values: [
      {
        title: "Reliability",
        text: "Trust in quality and punctual execution. Secure, stable installations for lasting performance.",
      },
      {
        title: "Competence",
        text: "Expertise and experience that convince and create real added value for demanding projects.",
      },
      {
        title: "Partnership",
        text: "Transparent, punctual and partnership-based cooperation – for long-term shared success.",
      },
      {
        title: "Sustainability",
        text: "Future-proof technologies for sustainable and responsible implementation.",
      },
    ],
    regions: {
      overline: "Service area",
      title: "Working for you across Switzerland and Southern Germany",
      text: "We serve clients throughout Switzerland as well as in Baden-Württemberg and Bavaria.",
      list: ["Switzerland", "Baden-Württemberg", "Bavaria"],
    },
    ctaBand: {
      title: "Ready for your next project?",
      text: "Let's talk about your requirements – we are happy to advise you personally.",
      button: "Contact us now",
    },
    about: {
      overline: "About us",
      title: "Technology. Competence. Trust.",
      lead: "Elvocom AG is an innovative company for high-quality services and individual solutions in electrical and IT/IT-systems technology.",
      body1:
        "We support private clients, commercial customers and partner companies with excellent technical expertise and additional capacity – reliably and flexibly. Our approach is structured, quality-conscious and solution-oriented.",
      body2:
        "Transparent communication, personal commitment and on-time completion are a matter of course for us. With innovative strength, experience and a clear quality standard, we deliver economical and future-proof solutions at the highest level.",
      missionTitle: "Our commitment",
      mission:
        "Reliable solutions, competent consulting and sustainable added value – for long-term partnerships.",
      founderLabel: "Founder & Major Shareholder",
      founder: "Salvatore Giarratana",
    },
    teamPage: {
      overline: "Our team",
      title: "People who master technology",
      subtitle:
        "A well-coordinated team of electricians and telecommunications technicians.",
      roleManaging: "Managing Director · Electrician · Telecom technician",
      roleDeputy: "Deputy Management · Telecom technician",
      roleElectrician: "Electrician · Telecom technician",
      roleTelecom: "Telecommunications technician",
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your project",
      subtitle:
        "Fill out the form or contact us directly. We will get back to you promptly.",
      infoTitle: "Contact details",
      addressLabel: "Address",
      phoneLabel: "Phone",
      emailLabel: "Email",
      form: {
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "your@email.com",
        phone: "Phone (optional)",
        phonePlaceholder: "+41 ...",
        subject: "Subject",
        subjectPlaceholder: "What is it about?",
        message: "Message",
        messagePlaceholder: "Describe your request ...",
        submit: "Send request",
        sending: "Sending ...",
        success: "Thank you! Your request has been sent.",
        error: "An error occurred. Please try again.",
        newRequest: "New request",
      },
    },
    footer: {
      tagline: "Reliable solutions. Sustainable connections.",
      nav: "Navigation",
      services: "Services",
      contact: "Contact",
      rights: "All rights reserved.",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
    },
    legal: {
      impressumTitle: "Imprint",
      datenschutzTitle: "Privacy Policy",
      impressum: {
        companyHeading: "Company details",
        representedByLabel: "Represented by",
        representedBy: "Salvatore Giarratana (Managing Director)",
        contactHeading: "Contact",
        registerHeading: "Commercial register",
        uidLabel: "UID / Commercial register no.",
        uid: "CHE-165.598.626",
        disclaimerHeading: "Disclaimer",
        disclaimer:
          "The content of this website has been compiled with the greatest possible care. However, we assume no liability for the accuracy, completeness or timeliness of the content. The operators of external linked sites are solely responsible for their content.",
        copyrightHeading: "Copyright",
        copyright:
          "All content on this website (texts, images, logo, graphics) is protected by copyright and may not be reproduced or used without the prior written consent of Elvocom AG.",
      },
      datenschutz: {
        intro:
          "The protection of your personal data is important to us. We treat your personal data confidentially and in accordance with the Swiss Data Protection Act (revFADP) and, where applicable, the EU General Data Protection Regulation (GDPR).",
        sections: [
          { h: "1. Controller", p: "The controller for data processing on this website is Elvocom AG, Wildenstrasse 3, 8212 Neuhausen am Rheinfall. For data protection questions, contact us at info@elvocom.ch." },
          { h: "2. Data collected when visiting the website", p: "When you access our website, technical access data (e.g. IP address, date and time, page accessed, browser type) is automatically stored in server log files. This data is used solely for the secure and stable operation of the website." },
          { h: "3. Contact form", p: "If you send us a request via the contact form, we process the data you provide (name, email address, phone number if given, subject and message) to handle your request. The data is stored in our database and additionally sent to us by email. We keep this data for as long as necessary to process your request." },
          { h: "4. Cookies & local storage", p: "We do not use tracking or advertising cookies. To store your preferred language we only use technically necessary local storage (localStorage) in your browser." },
          { h: "5. Disclosure to third parties", p: "Your data is not sold. It is only shared with service providers required to operate the website and send emails (hosting and email providers), or where we are legally obliged to do so." },
          { h: "6. Your rights", p: "You have the right to information, correction, deletion and restriction of the processing of your personal data, as well as the right to data portability. Please contact us at info@elvocom.ch." },
          { h: "7. Changes", p: "We reserve the right to amend this privacy policy so that it always complies with current legal requirements." },
        ],
      },
    },
  },

  it: {
    nav: {
      home: "Home",
      services: "Servizi",
      about: "Chi siamo",
      team: "Team",
      contact: "Contatto",
      cta: "Contattaci",
    },
    hero: {
      overline: "Tecnologia elettrica e IT/EDP",
      title: "Soluzioni affidabili. Connessioni sostenibili.",
      subtitle:
        "Elvocom AG realizza soluzioni precise, efficienti e a prova di futuro nella tecnologia elettrica e IT/EDP – per clienti privati, commerciali e istituzionali.",
      primaryCta: "Richiedi un progetto",
      secondaryCta: "I nostri servizi",
      tagline: "Tecnica. Competenza. Fiducia.",
    },
    stats: [
      { value: "4", labelKey: "Aree tecnologiche principali" },
      { value: "100%", labelKey: "Puntualità e qualità" },
      { value: "CH · DE", labelKey: "Svizzera e Germania meridionale" },
    ],
    intro: {
      overline: "Chi siamo",
      title: "Il vostro partner per la tecnologia elettrica e di comunicazione",
      text: "Offriamo soluzioni complete nella tecnologia elettrica e IT/EDP. Con un'eccellente competenza tecnica e capacità aggiuntiva, supportiamo clienti privati, committenti commerciali e aziende partner – in modo affidabile e flessibile. Il nostro metodo di lavoro è strutturato, orientato alla qualità e alle soluzioni.",
      cta: "Scopri di più",
    },
    servicesSection: {
      overline: "Servizi",
      title: "Cosa realizziamo per voi",
      subtitle:
        "Dalla fibra ottica all'impianto elettrico completo – tutto da un unico fornitore.",
      viewAll: "Vedi tutti i servizi",
    },
    services: [
      {
        key: "fiber",
        title: "Fibra ottica / LWL",
        short: "Posa, giunzione e messa in servizio di cavi in fibra ottica.",
        points: [
          "Installazione e montaggio di cavi in fibra ottica",
          "Giunzione e tecnologia di misurazione",
          "Messa in servizio e documentazione completa",
        ],
      },
      {
        key: "network",
        title: "Rete / IT / Comunicazione",
        short: "Progettazione, cablaggio strutturato e tecnologia di rete.",
        points: [
          "Progettazione e consulenza per soluzioni di rete",
          "Cablaggio strutturato (es. cablaggio CAT)",
          "Configurazione, documentazione e manutenzione",
        ],
      },
      {
        key: "broadband",
        title: "Banda larga / Cavo / Satellite – Internet & TV",
        short: "Installazione di impianti banda larga, cavo, SAT e TV.",
        points: [
          "Installazione di impianti banda larga e via cavo",
          "Realizzazione di impianti di ricezione SAT e TV",
          "Distribuzione del segnale, cablaggio domestico e dispositivi",
        ],
      },
      {
        key: "electro",
        title: "Elettro",
        short: "Impianti elettrici per immobili privati e commerciali.",
        points: [
          "Impianti elettrici e lavori elettronici",
          "Per immobili privati e commerciali",
          "Modernizzazione ed ampliamento di sistemi esistenti",
        ],
      },
    ],
    valuesSection: {
      overline: "I nostri valori",
      title: "Perché i clienti si fidano di noi",
    },
    values: [
      {
        title: "Affidabilità",
        text: "Fiducia nella qualità e nell'esecuzione puntuale. Installazioni sicure e stabili per prestazioni durature.",
      },
      {
        title: "Competenza",
        text: "Conoscenza ed esperienza che convincono e creano valore aggiunto per progetti impegnativi.",
      },
      {
        title: "Partnership",
        text: "Collaborazione trasparente, puntuale e basata sulla partnership – per un successo condiviso a lungo termine.",
      },
      {
        title: "Sostenibilità",
        text: "Tecnologie a prova di futuro per un'implementazione sostenibile e responsabile.",
      },
    ],
    regions: {
      overline: "Area di servizio",
      title: "Al vostro servizio in Svizzera e nella Germania meridionale",
      text: "Serviamo clienti in tutta la Svizzera così come nel Baden-Württemberg e in Baviera.",
      list: ["Svizzera", "Baden-Württemberg", "Baviera"],
    },
    ctaBand: {
      title: "Pronti per il vostro prossimo progetto?",
      text: "Parliamo delle vostre esigenze – saremo lieti di consigliarvi personalmente.",
      button: "Contattaci ora",
    },
    about: {
      overline: "Chi siamo",
      title: "Tecnica. Competenza. Fiducia.",
      lead: "Elvocom AG è un'azienda innovativa per servizi di alta qualità e soluzioni individuali nella tecnologia elettrica e IT/EDP.",
      body1:
        "Supportiamo clienti privati, committenti commerciali e aziende partner con un'eccellente competenza tecnica e capacità aggiuntiva – in modo affidabile e flessibile. Il nostro metodo di lavoro è strutturato, orientato alla qualità e alle soluzioni.",
      body2:
        "La comunicazione trasparente, l'impegno personale e il completamento puntuale sono per noi una cosa ovvia. Con capacità innovativa, esperienza e un chiaro standard qualitativo, realizziamo soluzioni economiche e a prova di futuro ai massimi livelli.",
      missionTitle: "Il nostro impegno",
      mission:
        "Soluzioni affidabili, consulenza competente e valore aggiunto sostenibile – per partnership a lungo termine.",
      founderLabel: "Fondatore e azionista di maggioranza",
      founder: "Salvatore Giarratana",
    },
    teamPage: {
      overline: "Il nostro team",
      title: "Persone che padroneggiano la tecnica",
      subtitle:
        "Un team affiatato di elettricisti e tecnici delle telecomunicazioni.",
      roleManaging: "Direttore · Elettricista · Tecnico telecomunicazioni",
      roleDeputy: "Vicedirezione · Tecnico telecomunicazioni",
      roleElectrician: "Elettricista · Tecnico telecomunicazioni",
      roleTelecom: "Tecnico delle telecomunicazioni",
    },
    contact: {
      overline: "Contatto",
      title: "Parliamo del vostro progetto",
      subtitle:
        "Compilate il modulo o contattateci direttamente. Vi risponderemo al più presto.",
      infoTitle: "Dati di contatto",
      addressLabel: "Indirizzo",
      phoneLabel: "Telefono",
      emailLabel: "E-mail",
      form: {
        name: "Nome",
        namePlaceholder: "Il vostro nome",
        email: "E-mail",
        emailPlaceholder: "vostra@email.ch",
        phone: "Telefono (opzionale)",
        phonePlaceholder: "+41 ...",
        subject: "Oggetto",
        subjectPlaceholder: "Di cosa si tratta?",
        message: "Messaggio",
        messagePlaceholder: "Descrivete la vostra richiesta ...",
        submit: "Invia richiesta",
        sending: "Invio in corso ...",
        success: "Grazie! La vostra richiesta è stata inviata.",
        error: "Si è verificato un errore. Riprovate.",
        newRequest: "Nuova richiesta",
      },
    },
    footer: {
      tagline: "Soluzioni affidabili. Connessioni sostenibili.",
      nav: "Navigazione",
      services: "Servizi",
      contact: "Contatto",
      rights: "Tutti i diritti riservati.",
      impressum: "Note legali",
      datenschutz: "Privacy",
    },
    legal: {
      impressumTitle: "Note legali",
      datenschutzTitle: "Informativa sulla privacy",
      impressum: {
        companyHeading: "Dati dell'azienda",
        representedByLabel: "Rappresentata da",
        representedBy: "Salvatore Giarratana (Direttore)",
        contactHeading: "Contatto",
        registerHeading: "Registro di commercio",
        uidLabel: "UID / N. registro di commercio",
        uid: "CHE-165.598.626",
        disclaimerHeading: "Esclusione di responsabilità",
        disclaimer:
          "I contenuti di questo sito web sono stati redatti con la massima cura possibile. Tuttavia non forniamo alcuna garanzia in merito all'esattezza, completezza e attualità dei contenuti. Per i contenuti dei link esterni sono responsabili esclusivamente i rispettivi gestori.",
        copyrightHeading: "Diritti d'autore",
        copyright:
          "Tutti i contenuti di questo sito web (testi, immagini, logo, grafica) sono protetti da copyright e non possono essere riprodotti o utilizzati senza il previo consenso scritto di Elvocom AG.",
      },
      datenschutz: {
        intro:
          "La protezione dei vostri dati personali è per noi importante. Trattiamo i vostri dati personali in modo riservato e in conformità con la legge svizzera sulla protezione dei dati (nLPD) e, ove applicabile, con il Regolamento generale dell'UE sulla protezione dei dati (GDPR).",
        sections: [
          { h: "1. Titolare del trattamento", p: "Il titolare del trattamento dei dati su questo sito web è Elvocom AG, Wildenstrasse 3, 8212 Neuhausen am Rheinfall. Per domande sulla protezione dei dati, contattateci a info@elvocom.ch." },
          { h: "2. Raccolta dei dati durante la visita", p: "Quando accedete al nostro sito web, i dati tecnici di accesso (ad es. indirizzo IP, data e ora, pagina richiesta, tipo di browser) vengono automaticamente memorizzati nei file di log del server. Questi dati servono esclusivamente al funzionamento sicuro e stabile del sito." },
          { h: "3. Modulo di contatto", p: "Se ci inviate una richiesta tramite il modulo di contatto, trattiamo i dati da voi forniti (nome, indirizzo e-mail, eventuale numero di telefono, oggetto e messaggio) per gestire la vostra richiesta. I dati vengono memorizzati nel nostro database e inoltre inviati a noi via e-mail. Conserviamo questi dati per il tempo necessario a evadere la richiesta." },
          { h: "4. Cookie e archiviazione locale", p: "Non utilizziamo cookie di tracciamento o pubblicitari. Per memorizzare la lingua preferita utilizziamo esclusivamente l'archiviazione locale tecnicamente necessaria (localStorage) nel vostro browser." },
          { h: "5. Comunicazione a terzi", p: "I vostri dati non vengono venduti. Vengono condivisi solo con i fornitori di servizi necessari al funzionamento del sito e all'invio delle e-mail (fornitori di hosting ed e-mail) o quando siamo legalmente obbligati a farlo." },
          { h: "6. I vostri diritti", p: "Avete il diritto di accesso, rettifica, cancellazione e limitazione del trattamento dei vostri dati personali, nonché il diritto alla portabilità dei dati. Contattateci a info@elvocom.ch." },
          { h: "7. Modifiche", p: "Ci riserviamo il diritto di modificare la presente informativa sulla privacy affinché sia sempre conforme ai requisiti di legge vigenti." },
        ],
      },
    },
  },
};
